export enum QueryParam {
  COLOR_INDEX = 'color',
  SELECTED_COLORS = 'colors',
  SELECTED_SIZES = 'sizes',
}
